import { configureStore } from "@reduxjs/toolkit"
import globalReducer from "./globalSlice"

export const store = configureStore({
  reducer: {
    global: globalReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [],
        // Ignore these field paths in all actions
        ignoredActionPaths: [
          "payload.chanceCards",
          "payload.communityChestCards",
          "payload.playerListItems",
          "payload.jailOverlay",
        ],
        // Ignore these paths in the state
        ignoredPaths: [
          "global.elements.playerListItems",
          "global.elements.chanceCards",
          "global.elements.communityChestCards",
          "global.elements.jailOverlay",
          "global.modal", // React component is not serializable
        ],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

